import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Select,
  Input,
  Form,
  Button,
 
} from "antd";
import {
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
import "../home-page.css";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import agent from "../../../agent";
import {
  LOGIN,
  SERVICELIST,
  DISTANCE,
} from "../../../core-units/constants/actionTypes";
import bannerBG from "../../../assets/img/bannerBG.png";
import _, { isEmpty } from "lodash";
import Ripples from "react-ripples";
import { connect } from "react-redux";
const { Option } = Select;

const Locations = (props) => {
  const homeLocation = "Ste 975/585 Little Collins St, Melbourne VIC 3000, Australia";
  const [selectedValuelocation, setSelectedValuelocation] = useState("");
  const [location_search_data, setLocation_search_data] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [locDiff, setLocDiff] = useState(0);
  const loginAttempted = useRef(false); // log in only once per page load

  // NEW: autocomplete state
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const sessionTokenRef = useRef(null);
  const latestRequestRef = useRef(0);

  const parseLocationData = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch (error) {
      // ignore invalid JSON
    }
    if (typeof value === "string" && value.includes(",")) {
      return value.split(",").map((item) => Number(item.trim()));
    }
    return [];
  };

  const location = useLocation();
  const isEV = location.pathname.includes("/ev");

  const handleLogin = () => {
    if (loginInProgress || loginAttempted.current) {
      return;
    }
    loginAttempted.current = true; // one automatic attempt per page load

    props.auth({}, () => {
      props.servicesList();
    });
  };

  const authLoggedInValue = _.get(props, "authState.signupDetails.isLoggedIn", false);
  const loginInProgress = _.get(props, "authState.inProgress", false);
  const storedLoginStatus = localStorage.getItem("safebuyLoggedInStatus");
  const isLoggedIn =
    authLoggedInValue === true ||
    authLoggedInValue === "true" ||
    storedLoginStatus === "true";

  useEffect(() => {
    setLocDiff(localStorage.getItem("diffLoc"));
    setLocation_search_data(
      parseLocationData(localStorage.getItem("location_search_data"))
    );
    setSelectedValuelocation(localStorage.getItem("selectedValuelocation") || "");
  }, []);

  // Auth check: runs once, no retry loop
  useEffect(() => {
    if (!isLoggedIn && !loginInProgress) {
      handleLogin();
    }
  }, [isLoggedIn, loginInProgress]);

  /** ---------- Places API (New) autocomplete ---------- */

  // Loads the Places library (works with the classic <script ...libraries=places> tag)
  const loadPlacesLibrary = async () => {
    if (window.google?.maps?.importLibrary) {
      return window.google.maps.importLibrary("places");
    }
    return window.google.maps.places;
  };

  // Debounced fetch of suggestions
  const fetchSuggestions = useMemo(
    () =>
      _.debounce(async (input) => {
        const requestId = ++latestRequestRef.current;

        if (!input || input.trim().length < 2) {
          setSuggestions([]);
          setSuggestionsLoading(false);
          return;
        }

        try {
          setSuggestionsLoading(true);
          const { AutocompleteSessionToken, AutocompleteSuggestion } =
            await loadPlacesLibrary();

          if (!sessionTokenRef.current) {
            sessionTokenRef.current = new AutocompleteSessionToken();
          }

          const { suggestions: results } =
            await AutocompleteSuggestion.fetchAutocompleteSuggestions({
              input,
              includedRegionCodes: ["au"], // ISO 3166-1 alpha-2 (was "aus")
              sessionToken: sessionTokenRef.current,
            });

          // Ignore stale responses
          if (requestId !== latestRequestRef.current) return;

          setSuggestions(
            results.map((s) => s.placePrediction).filter(Boolean)
          );
        } catch (error) {
          console.error("[Location] Autocomplete error", error);
          if (requestId === latestRequestRef.current) setSuggestions([]);
        } finally {
          if (requestId === latestRequestRef.current) {
            setSuggestionsLoading(false);
          }
        }
      }, 300),
    []
  );

  // Cancel any pending debounced call on unmount
  useEffect(() => {
    return () => fetchSuggestions.cancel();
  }, [fetchSuggestions]);

  /**Location search */
  const handleChange = (event) => {
    const address = event.target.value;
    setSelectedValuelocation(address);
    fetchSuggestions(address);
  };

  /**Location select */
  const handleSelect = async (prediction) => {
    const address = prediction.text.text;

    // Show the chosen address immediately and close the dropdown
    fetchSuggestions.cancel();
    latestRequestRef.current += 1;
    setSelectedValuelocation(address);
    setSuggestions([]);

    try {
      const place = prediction.toPlace();
      await place.fetchFields({ fields: ["location", "formattedAddress"] });
      locationDifference({
        lat: place.location.lat(),
        lng: place.location.lng(),
      });
    } catch (error) {
      console.error("Error", error);
    } finally {
      // A selection ends the billing session; start a new one next time
      sessionTokenRef.current = null;
    }
  };

  const locationDifference = (latLng) => {
    const latLngD = [latLng.lat, latLng.lng];
    setLocation_search_data(latLngD);
  };

  /**Submit function  */
  const onSubmit = () => {
    if (
      !isEmpty(selectedValuelocation) ||
      !_.isEmpty(localStorage.getItem("selectedValuelocation"))
    ) {
      localStorage.removeItem("value");
      localStorage.removeItem("service");
      localStorage.removeItem("total");
      localStorage.removeItem("product");
      props.servicesList();
      document.getElementById("sample").scrollIntoView({
        behavior: "smooth",
      });

      // window.scrollTo(0, 5)
      props.servicesList();
      const origin = homeLocation;
      const destination = selectedValuelocation;

      props.distance(
        {
          origin,
          destination,
          destinationAddress: selectedValuelocation,
          mode: "driving",
        },
        (value) => {
          console.log("Distance API response (home):", value);
          const routes = _.get(value, "routes", []);
          let shortestDistanceKm = 0;

          if (routes.length > 0) {
            let shortestDistanceMeters = Number.MAX_SAFE_INTEGER;

            routes.forEach((route) => {
              (route.legs || []).forEach((leg) => {
                const distanceMeters = _.get(leg, "distanceMeters", _.get(leg, "distance.value", 0));
                if (distanceMeters < shortestDistanceMeters) {
                  shortestDistanceMeters = distanceMeters;
                }
              });
            });

            shortestDistanceKm = shortestDistanceMeters / 1000;
          }

          console.log("Shortest distance selected (home):", shortestDistanceKm);
          setLocDiff(shortestDistanceKm);
          setFetching(false);
          localStorage.setItem("diffLoc", shortestDistanceKm);
        },
      );
      localStorage.setItem("selectedValuelocation", selectedValuelocation);
      localStorage.setItem(
        "location_search_data",
        JSON.stringify(location_search_data)
      );
    }
  };

  //Edit Function --------

  const onEdit = () => {
    [
      "value",
      "service",
      "total",
      "product",
      "selectedValuelocation",
      "location_search_data",
      "diffLoc",
    ].forEach((key) => localStorage.removeItem(key));

    setSelectedValuelocation("");
    setLocation_search_data([]);
    setLocDiff(0);
    setSuggestions([]);

    if (props.routingValidation.edit === 0) {
      setFetching(true);
    }
    if (props.routingValidation.edit === 1) {
      props.routingValidation.home();
    }
    if (props.routingValidation.edit === 2) {
      props.routingValidation.home();
    }
    if (props.routingValidation.edit === 3) {
      props.routingValidation.home();
    }
    if (props.routingValidation.edit === 4) {
      props.routingValidation.home();
    }
  };

  const render = () => {
    const isInputEditable =
      props.routingValidation.route === false &&
      _.isEmpty(localStorage.getItem("selectedValuelocation"));

    return (
      <div
        className="BannerSection"
        style={{ backgroundImage: `url(${bannerBG})` }}
      >
        <div className="BannerTextContainer">
          <div className="container">
            <div className="row">
              <div className="col-8 col-md-4">
                <div className="BannerTextTitle">
                  <span className="text-nowrap">Whenever you buy</span>
                  <span className="txt-brown">SafeBuy</span>
                </div>
                <div className="BannerTextDesc">
                  <b>
                    Book your inspection by entering the car location (
                    <span className="address">Complete address</span>) in the
                    box below
                  </b>
                </div>
                <div className="BannerInputContainer">
                  <Form>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please fill the location",
                        },
                      ]}
                    >
                      <div>
                        <Input
                          value={selectedValuelocation}
                          onChange={handleChange}
                          placeholder="585 Collins Street, Melbourne , VIC 3000"
                          className="location-search-input"
                          autoComplete="off"
                          disabled={!isInputEditable}
                          required
                        />

                        {_.isEmpty(selectedValuelocation) ? (
                          <span className="location-error-message">
                            Please fill this field!
                          </span>
                        ) : (
                          ""
                        )}
                        <div className="autocomplete-dropdown-container">
                          {suggestionsLoading && <div>Loading...</div>}
                          {suggestions.map((prediction) => (
                            <div
                              key={prediction.placeId}
                              role="option"
                              className="suggestion-item"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSelect(prediction)}
                            >
                              <span>{prediction.text.text}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Form.Item>
                    <Form.Item>
                      <Ripples className="buttonRipple">
                        <Button
                          onClick={isInputEditable ? onSubmit : onEdit}
                          id="sample"
                        >
                          {isInputEditable ? "Get Started" : "Edit / Change"}
                        </Button>
                      </Ripples>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return render();
};

const mapStateToProps = (state) => ({
  authState: state.auth, // renamed: "auth" is the dispatch function below
});
const mapDispatchToProps = (dispatch) => ({
  auth: (params, callback) =>
    dispatch({
      type: LOGIN,
      payload: agent.Auth.login(params),
      successNotification: false,
      callback: callback,
    }),
  servicesList: (params, callback) =>
    dispatch({
      type: SERVICELIST,
      payload: agent.Services.list(params),
      callback: callback,
    }),
  distance: (params, callback) =>
    dispatch({
      type: DISTANCE,
      payload: agent.Auth.google_location(params),
      callback: callback,
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(Locations);
